import React from "react";

const OrderSetIdContext = React.createContext<string | null>(null);
export default OrderSetIdContext;
